import _sortBy from 'lodash/sortBy';

/**
 * @param {Object[]} fieldsArray
 * @param {string} groupTitle
 * @returns {Object[][]}
 */
export default function generateGroups(fieldsArray, groupTitle = 'Custom fields') {
  const newItems = fieldsArray.map((item) => ({ ...item }));
  const customFieldsMap = {};
  newItems.forEach((customField) => {
    customFieldsMap[customField.id || customField.title] = { ...customField };
  });

  const customFields = _sortBy(newItems, ['order']).map(
    (customField) => customFieldsMap[customField.id || customField.title],
  );

  return customFields.reduce((acc, value) => {
    if (value.type === 'separator') {
      acc.push([value]);
    } else {
      if (!acc.length) {
        acc.push([{
          type: 'separator', title: groupTitle, visibility: 'visible', notRemovable: true,
        }]);
      }
      acc[acc.length - 1].push(value);
    }
    return acc;
  }, []);
}
